import { freeBusyCache } from 'owa-freebusy-cache';
import getStore from '../store/store';
import {
    fetchRoomsAvailability,
    fetchRoomsAvailabilityForRoomPanel,
} from '../actions/calendarRoomActions';
import type { Room } from '../components/RoomSelector/RoomSelector.types';
import { orchestrator } from 'satcheljs';

orchestrator(
    fetchRoomsAvailabilityForRoomPanel,
    ({
        eventStartDate,
        eventEndDate,
        isAllDayEvent,
        recurrence,
        requiredAttendees,
        optionalAttendees,
        originalEvent,
    }) => {
        const rooms = getStore().roomListViewState.rooms || [];

        // no filter for new event
        if (!originalEvent.ItemId) {
            fetchRoomsAvailability(
                rooms,
                freeBusyCache,
                eventStartDate,
                eventEndDate,
                isAllDayEvent,
                recurrence,
                requiredAttendees,
                optionalAttendees
            );

            return;
        }

        // query rooms availability with filter if they are the meeting rooms of the event.
        const resources = originalEvent.Resources;
        let eventRooms: Room[] = [];
        let nonEventRooms: Room[] = [];

        for (let i = 0; i < rooms.length; ++i) {
            if (
                resources &&
                resources.some(resource => {
                    return resource.Mailbox.EmailAddress == rooms[i].email;
                })
            ) {
                eventRooms.push(rooms[i]);
            } else {
                nonEventRooms.push(rooms[i]);
            }
        }

        fetchRoomsAvailability(
            nonEventRooms,
            freeBusyCache,
            eventStartDate,
            eventEndDate,
            isAllDayEvent,
            recurrence,
            requiredAttendees,
            optionalAttendees
        );

        fetchRoomsAvailability(
            eventRooms,
            freeBusyCache,
            eventStartDate,
            eventEndDate,
            isAllDayEvent,
            recurrence,
            requiredAttendees,
            optionalAttendees,
            originalEvent
        );
    }
);
